import React from "react";
import PropTypes from "prop-types";
import ReactMarkdown from "react-markdown";
import remarkBreaks from "remark-breaks";

import { PageBase } from "../PageBase";

import BEM from "./TextPage.module.css";

export const TextPage = ({ heading, mdString, children }) => {
    return (
        <div className={BEM.block}>
            <div className={BEM.wrapper}>
                <PageBase heading={heading}>
                    {children ? (
                        <>
                            {children}
                            <br />
                        </>
                    ) : (
                        ""
                    )}
                    <ReactMarkdown
                        className={BEM.contentActually}
                        plugins={[remarkBreaks]}
                    >
                        {mdString}
                    </ReactMarkdown>
                </PageBase>
            </div>
        </div>
    );
};

TextPage.propTypes = {
    heading: PropTypes.node,
    mdString: PropTypes.string.isRequired,
};
